const MIXTE_DISPENSARY_AREA_MAP = {
  externalClinic: '1',
  generalCare: '3',
  remote: '53'
};

export default MIXTE_DISPENSARY_AREA_MAP;
